import { DocumentNode } from 'graphql';
import { ApolloClient } from 'apollo-client';

import { ResolveParams, ResolveWeakParams } from '../utils/resolve';

import { syncReadFromClient } from './syncReadFromClient';
import { resolveFromNetwork } from './urlResolver';

interface UrqlResolvers {
    resolveFromNetwork: ResolveParams['resolveFromNetwork'];
    syncReadFromClient: ResolveWeakParams['syncReadFromClient'];
}

/**
 * apollo client
 * @param client
 * @param query
 */
export function resolvers(client: ApolloClient<any>, query: DocumentNode | string): UrqlResolvers {
    return {
        resolveFromNetwork: (urlKey: string) =>
            resolveFromNetwork({
                client,
                query: query as DocumentNode,
                urlKey,
            }),
        syncReadFromClient: (urlKey) => syncReadFromClient(client, urlKey, query),
    };
}
